var _excluded = ["className", "day", "dayProps", "disabled", "error", "isAssertiveError", "label", "marginBottom", "marginLeft", "marginRight", "marginTop", "month", "monthProps", "name", "onBlur", "onChange", "optional", "supportiveText", "tooltip", "valid", "variation", "year", "yearProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import FieldLabel from "../FieldLabel";
import LabeledField from "../LabeledField";
import TextInput from "../TextInput";
import StyledMemorableDateContainer, { StyledMemorableDateInputContainer, StyledMemorableDateSpan } from "./styled";
var MemorableDate = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var customClassName = _ref.className,
    notInUseDay = _ref.day,
    _ref$dayProps = _ref.dayProps,
    dayProps = _ref$dayProps === void 0 ? {} : _ref$dayProps,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    isAssertiveError = _ref.isAssertiveError,
    label = _ref.label,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    marginTop = _ref.marginTop,
    notInUseMonth = _ref.month,
    _ref$monthProps = _ref.monthProps,
    monthProps = _ref$monthProps === void 0 ? {} : _ref$monthProps,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    optional = _ref.optional,
    supportiveText = _ref.supportiveText,
    tooltip = _ref.tooltip,
    valid = _ref.valid,
    _ref$variation = _ref.variation,
    variation = _ref$variation === void 0 ? 'dmy' : _ref$variation,
    notInUseYear = _ref.year,
    _ref$yearProps = _ref.yearProps,
    yearProps = _ref$yearProps === void 0 ? {} : _ref$yearProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(notInUseDay),
    _useState2 = _slicedToArray(_useState, 2),
    day = _useState2[0],
    setDay = _useState2[1];
  var _useState3 = useState(notInUseMonth),
    _useState4 = _slicedToArray(_useState3, 2),
    month = _useState4[0],
    setMonth = _useState4[1];
  var _useState5 = useState(notInUseYear),
    _useState6 = _slicedToArray(_useState5, 2),
    year = _useState6[0],
    setYear = _useState6[1];
  useEffect(function () {
    setDay(notInUseDay);
  }, [notInUseDay]);
  useEffect(function () {
    setMonth(notInUseMonth);
  }, [notInUseMonth]);
  useEffect(function () {
    setYear(notInUseYear);
  }, [notInUseYear]);
  var handleDayChange = function handleDayChange(_ref2) {
    var dayValue = _ref2.target.value;
    var dayNumber = Number(dayValue);
    if (dayNumber > 31 || isNaN(dayNumber) || dayValue === '00' || dayValue.includes('.')) return;
    setDay(dayValue);
    if (onChange) onChange({
      day: dayValue,
      month: month,
      year: year
    });
  };
  var handleMonthChange = function handleMonthChange(_ref3) {
    var monthValue = _ref3.target.value;
    var monthNumber = Number(monthValue);
    if (monthNumber > 12 || isNaN(monthNumber) || monthValue === '00' || monthValue.includes('.')) return;
    setMonth(monthValue);
    if (onChange) onChange({
      day: day,
      month: monthValue,
      year: year
    });
  };
  var handleYearChange = function handleYearChange(_ref4) {
    var yearValue = _ref4.target.value;
    var yearNumber = Number(yearValue);
    if (isNaN(yearNumber) || yearValue.slice(0, 1) === '0' || yearValue.includes('.')) return;
    setYear(yearValue);
    if (onChange) onChange({
      day: day,
      month: month,
      year: yearValue
    });
  };
  var isDayEnabled = useMemo(function () {
    return variation.indexOf('d') > -1;
  }, [variation]);
  var isYearEnabled = useMemo(function () {
    return variation.indexOf('y') > -1;
  }, [variation]);
  var commonInputProps = {
    'aria-describedby': "".concat(name, "-hint ").concat(name, "-error"),
    disabled: disabled,
    error: Boolean(error),
    inputMode: 'numeric',
    onBlur: onBlur,
    pattern: '[0-9]*',
    required: !optional,
    valid: valid
  };
  var classNames = useMemo(function () {
    return classnames('csl-memorable-date', customClassName);
  }, [customClassName]);
  return /*#__PURE__*/React.createElement(LabeledField, _extends({
    as: "fieldset",
    className: classNames,
    createChildProps: false,
    disabled: disabled,
    error: error,
    isAssertiveError: isAssertiveError,
    label: label,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    name: name,
    optional: optional,
    ref: ref,
    supportiveText: supportiveText,
    tooltip: tooltip
  }, rest), /*#__PURE__*/React.createElement(StyledMemorableDateContainer, null, isDayEnabled && /*#__PURE__*/React.createElement(StyledMemorableDateInputContainer, {
    className: "csl-memorable-date__label"
  }, /*#__PURE__*/React.createElement(FieldLabel, {
    htmlFor: "".concat(name, "-day"),
    weight: "normal"
  }, "Day"), /*#__PURE__*/React.createElement(StyledMemorableDateSpan, {
    $chars: 2,
    className: "csl-memorable-date__2-chars"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    maxLength: 2,
    name: "".concat(name, "-day"),
    onChange: handleDayChange,
    placeholder: "DD",
    value: day === undefined ? '' : day
  }, commonInputProps, dayProps)))), /*#__PURE__*/React.createElement(StyledMemorableDateInputContainer, {
    className: "csl-memorable-date__label csl-memorable-date__label--month"
  }, /*#__PURE__*/React.createElement(FieldLabel, {
    htmlFor: "".concat(name, "-month"),
    weight: "normal"
  }, "Month"), /*#__PURE__*/React.createElement(StyledMemorableDateSpan, {
    $chars: 2,
    className: "csl-memorable-date__2-chars"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    maxLength: 2,
    name: "".concat(name, "-month"),
    onChange: handleMonthChange,
    placeholder: "MM",
    value: month === undefined ? '' : month
  }, commonInputProps, monthProps)))), isYearEnabled && /*#__PURE__*/React.createElement(StyledMemorableDateInputContainer, {
    className: "csl-memorable-date__label"
  }, /*#__PURE__*/React.createElement(FieldLabel, {
    htmlFor: "".concat(name, "-year"),
    weight: "normal"
  }, "Year"), /*#__PURE__*/React.createElement(StyledMemorableDateSpan, {
    $chars: 4,
    className: "csl-memorable-date__4-chars"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    maxLength: 4,
    name: "".concat(name, "-year"),
    onChange: handleYearChange,
    placeholder: "YYYY",
    value: year === undefined ? '' : year
  }, commonInputProps, yearProps))))));
});
MemorableDate.displayName = 'MemorableDate';
export default MemorableDate;